'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1399qju-0"
})(["padding:1.5rem;display:flex;justify-content:center;flex-direction:column;", ""], _ref => {
  let {
    theme
  } = _ref;
  return theme.bodytextDefaultNone;
});
const PudoElmWrap = styled__default["default"].div.withConfig({
  componentId: "sc-1399qju-1"
})(["display:flex;justify-content:center;flex-direction:column;width:100%;align-items:center;"]);

exports.PudoElmWrap = PudoElmWrap;
exports.Wrapper = Wrapper;
